import React, { memo, useMemo } from 'react';

import { useTheme } from '@mui/material';
import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel/TooltipedSortLabel.constants';
import PropTypes from 'prop-types';

const inactiveColor = 'transparent';

const SortIconCDS = ({ direction, size = 16 }) => {
  const { palette, transition } = useTheme();

  const isNone = direction === SORT_DIRECTIONS.NONE;
  const isAsc = direction === SORT_DIRECTIONS.ASC;
  const isDesc = direction === SORT_DIRECTIONS.DESC;

  const activeColor = palette.text.secondary;

  const upColor = isNone || isAsc ? activeColor : inactiveColor;
  const downColor = isNone || isDesc ? activeColor : inactiveColor;

  const pathStyle = useMemo(() => ({ transition: transition?.default }), [transition?.default]);

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 16 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Up arrow */}
      <path d="M8 2L12 6H4L8 2Z" fill={upColor} style={pathStyle} />
      {/* Down arrow */}
      <path d="M8 14L4 10H12L8 14Z" fill={downColor} style={pathStyle} />
    </svg>
  );
};

SortIconCDS.propTypes = {
  direction: PropTypes.oneOf(Object.values(SORT_DIRECTIONS)).isRequired,
  size: PropTypes.number,
};

export default memo(SortIconCDS);
